import React from "react";
import InputField from "../../../components/InputField";
import TextAreaField from "../../../components/TextAreaField";
import UploadImage from "../api/UploadImage";
import updateItem from "../api/updateItem";
import { useState } from "react";

const EditForm = ({ item, setEditForm, setAlert, onImageUpdated }) => {
  const [formData, setFormData] = useState({
    name: item.name,
    desc: item.description,
    image: null,
  });

  // handle for every input change dynamic
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // handle Update Item for name and desc only
  const handleUpdatingItemDetails = async () => {
    // Check if the values are different from the initial values
    if (formData.name !== item.name || formData.desc !== item.description) {
      const detailsData = {
        itemId: item.id,
        name: formData.name,
        description: formData.desc,
      };

      const status = await updateItem(detailsData);
      if (status.message !== "Item updated !") {
        setAlert("error");
        return false; // Stop further execution
      } else {
        setAlert("update");
        return true;
      }
    }
    return true; // Success
  };

  const handleEditFormSubmit = async (e) => {
    e.preventDefault();
    let success = true;

    success = await handleUpdatingItemDetails();
    if (!success) return;

    if (formData.image) {
      // Only call API if a new file is selected
      const imageData = {
        dataId: item.id,
        imageFile: formData.image,
      };

      //   upload new Image
      const status = await UploadImage(imageData);
      if (status === 200) {
        setAlert("update");
        onImageUpdated();
      } else {
        setAlert("error");
      }
      setTimeout(() => {
        setAlert("null");
      }, 5000);
    }
    setEditForm((prev) => !prev);
  };

  return (
    <div className="modal mt-4 w-full">
      <InputField
        type="file"
        accept="image/*"
        label={"صورة المنتج"}
        name="image"
        dir="rtl"
        required={false}
        onChange={handleInputChange}
      />
      <InputField
        label={"الإسم"}
        name="name"
        value={formData.name}
        dir="rtl"
        required={true}
        onChange={handleInputChange}
      />
      <TextAreaField
        label={"وصف المنتج"}
        name="desc"
        value={formData.desc}
        dir="rtl"
        required={false}
        onChange={handleInputChange}
      />
      <button onClick={handleEditFormSubmit}>تعديل</button>
      <button onClick={() => setEditForm((prev) => !prev)}>إلغاء </button>
    </div>
  );
};

export default EditForm;
